module.exports = __webpack_public_path__ + "img/zone1schedule.1409955c.png";